import { cn } from "../../utils";

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("af-animate-pulse af-rounded-md af-bg-muted", className)}
      {...props}
    />
  );
}

export { Skeleton };
